(function () {
  function stopCarousel(poster) {
    var root = poster.closest('.hm-vc');
    if (!root) return;
    if (poster.closest('[data-clone]')) return;
    var car = poster.closest('hm-carousel');
    if (car && typeof car.stop === 'function') car.stop();
  }

  document.addEventListener(
    'click',
    function (event) {
      var poster = event.target.closest('[id^="Deferred-Poster-"]');
      if (!poster) return;
      stopCarousel(poster);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var poster = event.target.closest('[id^="Deferred-Poster-"]');
    if (!poster || !poster.closest('.hm-vc')) return;
    event.preventDefault();
    stopCarousel(poster);
    poster.click();
  });
})();
